import React, { forwardRef, useEffect, useRef, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import FixedNavBar from "@/components/fixedNavBar";
import { SearchBar, Image } from "antd-mobile";
import TableTbody from "@/components/tableTbody";
import { ITableColsRecently } from "@/type";
import CalendarTime from "@/components/calendarTime";
import { useFinanceOrderRecords } from "@/hooks/useOrderRecords";
import useCustomTranslation from "@/hooks/useTranslation";
const CalendarTimeChildComponent = forwardRef(CalendarTime);

const RecentlyRecharge: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const childRef = useRef<any>(null);
	const [firstPage, setFirstPage] = useState(true);
	const [value, setValue] = useState("");
	const params: any = {
		srcList: ["PAY", "DEPOSIT_PARENT", "CASH"],
		nickname: value,
	};
	const { data, targetData, hasMore, handleRefresh, handleFetchMore } =
		useFinanceOrderRecords(params, childRef);

	useEffect(() => {
		if (!firstPage) {
			setFirstPage(false);
			handleRefresh();
		}
	}, [value]);

	return (
		<div className="router-main">
			<FixedNavBar title={t("btnDepositWithdrawRecords")} />
			<div className={classes.timeSearchWrap}>
				<div className="search">
					<SearchBar
						value={value}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={handleRefresh}
						placeholder="Search"
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
					/>
				</div>
				<CalendarTimeChildComponent
					ref={childRef}
					onSubmit={handleRefresh}
				/>
			</div>
			<div style={{ flex: 1, overflow: "hidden" }}>
				<TableTbody
					ITableCols={ITableColsRecently}
					ITableData={data}
					targetData={targetData}
					handleRefresh={handleRefresh}
					handleFetchMore={handleFetchMore}
					hasMore={hasMore}
				/>
			</div>
		</div>
	);
};

export default RecentlyRecharge;

const useStyles = createUseStyles({
	timeSearchWrap: {
		padding: {
			top: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .search": {
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
		"& .timebox": {
			display: "flex",
			justifyContent: "space-between",
			padding: {
				top: pxToRem(10),
				bottom: pxToRem(10),
			},
			"& .time": {
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(17),
					right: pxToRem(15),
				},
				width: pxToRem(160),
				height: pxToRem(36),
				borderRadius: pxToRem(40),
				border: "1px solid #2F3A62",
				"& span": {
					flex: 1,
					overflow: "hidden",
					fontSize: pxToRem(12),
					fontWeight: "400",
					color: "#FFFFFF",
				},
			},
		},
	},
});
